class FixedButtonSubscribe {
  constructor() {
    var fixedButton = document.querySelector('.fixed-button');

    if(typeof(fixedButton) != 'undefined' && fixedButton != null) {
      document.querySelector('.fixed-button__close').addEventListener('click', function() {
        fixedButton.remove();
      });
    }
  }
}

const fixedButtonSubscribe = new FixedButtonSubscribe();